import { Document } from '../models/incident';
import { SocketMessageType } from '../models/websocket';
import { WhatsappMessage } from '../models/whatsapp';
import { mediaInfo } from '../shared/media';

export function messageCaption(message: WhatsappMessage): string {
  const text = message.message?.trim() || '';
  return (message.documentId || message.docUrl) && /^Media message of type \w+ received\.$/.test(text) ? '' : text;
}

export function messageDocument(message: WhatsappMessage): Document | null {
  let payload: Partial<Document> = {};
  const json = message.messageType === SocketMessageType.ProofOfWorkDocument
    ? message.extendedObject || message.dataObject : message.dataObject;
  if (json) {
    try { payload = JSON.parse(json) || {}; } catch { /* Flat fields still identify the attachment. */ }
  }
  const documentId = message.documentId || payload.documentId;
  const url = message.docUrl || payload.url;
  if (!documentId || !url) return null;
  const document = Object.assign(new Document(), payload, {
    documentId, url, incidentId: message.incidentId || 0,
    mimeType: message.mimeType || payload.mimeType,
    mediaKind: message.mediaKind || payload.mediaKind,
    description: payload.description || messageCaption(message) || 'Attachment',
    createdByUserId: payload.createdByUserId ?? message.senderId,
    createdByUserName: payload.createdByUserName || message.senderName,
  });
  // NULL is deliberate for new non-image attachments; do not turn it into POW.
  if (payload.documentClassificationId === undefined) {
    document.documentClassificationId = mediaInfo(document).kind === 'image' ? 1 : null;
  }
  return document;
}
